// @flow
import NotFoundPage from "../components/commons/404/notFound";
import CreateTicket from "../components/containers/ticketing/createTicket/createTicket";
import ViewTicket from "../components/containers/ticketing/viewTicket/viewTicket";
import TicketDashboard from "../components/containers/ticketing/ticketDashboard/ticketDashboard";
import BUSettings from "../components/containers/ticketing/buSettings/buSettings";
import CategorySettings from "../components/containers/ticketing/categorySettings/categorySettings";
import ResolverGroupParent from "../components/containers/ticketing/resolverGroup/resolverGroupParent";

const routesConfig: Array<any> = [
  {
    title: "CREATE TICKET",
    route: "/createticket/:id?",
    roles: [],
    component: CreateTicket,
    zoomuinewroute: true
  },
  {
    title: "VIEW TICKET",
    route: "/viewticket/:id",
    roles: [],
    component: ViewTicket,
    zoomuinewroute: true
  },
  {
    title: "BU SETTINGS",
    route: "/busettings",
    roles: [
      "ROLE_EDIT_TICKET_CE",
      "ROLE_MANAGE_BUSINESS_UNIT",
      "ROLE_MANAGE_CATEGORY"
    ],
    component: BUSettings,
    zoomuinewroute: true,
    exact: true
  },
  {
    title: "CATEGORY SETTINGS",
    route: "/categorySettings",
    roles: ["ROLE_EDIT_TICKET_CE", "ROLE_MANAGE_CATEGORY"],
    component: CategorySettings,
    zoomuinewroute: true,
    exact: true
  },
  {
    title: "RESOLVER GROUP",
    route: "/resolverGroup",
    roles: ["ROLE_EDIT_TICKET", "ROLE_MANAGE_RESOLVER_GROUP"],
    component: ResolverGroupParent,
    zoomuinewroute: true,
    exact: true
  },
  {
    title: "NotFound",
    route: "/pagenotfound",
    zoomuinewroute: true,
    roles: [],
    component: NotFoundPage,
    exact: true
  },
  {
    title: "TICKET DASHBOARD",
    route: "/",
    roles: [],
    component: TicketDashboard,
    zoomuinewroute: true,
    exact: false
  }
];

export default routesConfig;



// WEBPACK FOOTER //
// ./app/configs/routesConfig.js